import { Component, OnInit } from '@angular/core';
import { LazyLoadEvent } from 'primeng/api';
import { MessagesService } from '../messages/messages.service';
import { Storage } from './../../app/models/storage';
import { MaStorageService } from './ma-storage.service';
import { StoragePlateDTO } from '../models/storagePlateDTO';
import { PlateStatus } from '../models/process-step';

@Component({
  selector: 'app-ma-storage',
  templateUrl: './ma-storage.component.html',
  styleUrls: ['./ma-storage.component.css']
})
export class MaStorageComponent implements OnInit {

  _storageService: any;
  blocked = false;
  isName = 'storageName';
  isProcessStep = 'processStep';
  isPlatesStored = 'plateIDs';
  isActive = 'active';
  isAction = 'action';
  enteredPlateID: string;
  storageList: Array<any>;
  totalStorages: number;
  selectedLabId: string;
  displayDialog: boolean;
  displayPlatesDialog: boolean;
  displayDescriptionDialog: boolean;
  displayRestoreDialog: boolean;
  displayStoreDialog: boolean;
  storedPlatesHeader: string;
  descriptionHeader: string;
  restoreHeader: string;
  storeHeader: string;
  processStepOptions: Array<any>;
  storage: Storage;
  storageName: string;
  processStep: any;
  active: boolean;
  description: string;
  storageOBJ: Storage;
  listOfStorageLocationsPositiveSamples: Array<any>;
  storageLocationList: Array<any>;
  selectedStorageLocation: string;
  selectedStorage: Storage;
  storageEdit: boolean;
  processStepMap = new Map();
  storageEditIndex: any;
  loading: boolean = true;
  showActiveStorages: boolean = true;
  enteredRestorePlateID:string
  enteredStorePlateID: string
  multiRestorePlateList: Array<string> = []
  multiPlateCreatedAndStorageAsTrue : Array<{plateId:string,index:number}> = []
  multiStorePlateList: Array<{plateId:string,isProcessingPlate:boolean}> = []
  multiStoragePlateFromReception:Array<string> = []
  multiOldStorageList: Set<string>;
  disableStoreButton = false

  constructor(private _maStorageService: MaStorageService, private _messagesService: MessagesService) {
  }

  ngOnInit() {
    this.selectedLabId = JSON.parse(localStorage.getItem('lab')).lab._id;
    this.selectedStorageLocation = "";
    this.selectedStorage = new Storage();
    this.processStepOptions = [
      { name: 'Reception', value: 'RECEPTION' },
      { name: 'Recombine DNA', value: 'RECOMBINE_DNA' },
      { name: 'Fragment DNA', value: 'FRAGMENT_DNA' },
      { name: 'Precipitate DNA', value: 'PRECIPITATE_DNA' },
      { name: 'Resuspend DNA', value: 'RESUSPEND_DNA' },
      { name: 'Longtime', value: 'LONGTIME' },
    ];

    this.listOfStorageLocationsPositiveSamples = [
      { field: 'storageName', header: 'Name' },
      { field: 'processStep', header: 'Process Step' },
      { field: 'plateIDs', header: 'Plates Stored' },
      { field: 'active', header: 'Active' },
      { field: 'action', header: 'Action' },
    ];

    this.processStepMap.set('RECEPTION',{name:'Reception', value: 'RECEPTION'})
    this.processStepMap.set('RECOMBINE_DNA',{name:'Recombine_DNA', value: 'RECOMBINE_DNA'})
    this.processStepMap.set('FRAGMENT_DNA',{name:'Fragment DNA', value: 'FRAGMENT_DNA'})
    this.processStepMap.set('PRECIPITATE_DNA',{name:'Precipitate DNA', value: 'PRECIPITATE_DNA'})
    this.processStepMap.set('RESUSPEND_DNA',{name:'Resuspend DNA', value: 'RESUSPEND_DNA'})
    this.processStepMap.set('LONGTIME',{name:'Longtime', value: 'LONGTIME'})

    this.fetchStorageLocationList();
    this.storageEdit = false;
    this.multiOldStorageList = new Set()
  }

  showDialogToAdd() {
    this.displayDialog = true;

    this.storageName='';
    this.processStep = "";
    this.description ='';
    this.active = true;
}

  addStorage(){
    if(!this.checkFormValidity())
    return;

    let storageOBJ = new Storage();
    storageOBJ.storageName = this.storageName;
    storageOBJ.processStep = this.processStep.value;
    storageOBJ.description = this.description;
    storageOBJ.labID = this.selectedLabId;
    storageOBJ.active = this.active;
    storageOBJ.plateIDs = [];
    storageOBJ.version = 0;
    this.displayDialog = false;

    this._maStorageService.saveStorageDetails(storageOBJ).subscribe(
      (result)=>{
        if (this.totalStorages>=10)
          this.storageList.pop();
        this.storageList.unshift(result);
        this.totalStorages+=1;
        this.fetchStorageLocationList();
      },
      (error)=>{
        this._messagesService.addErrorMessage({
          severity: 'error', summary: 'Storage not created.',
          detail: error.error
        });
      }
    )
  }

  clearStorage(){
    //pop up delete button
    this.storageName = null;
    this.processStep = null;
    this.description = null;
  }

  editStorage(index: any){
    this.storageEdit = true;
    this.storageEditIndex = index;
    this.selectedStorage = this.storageList[index];
    this.storageName = this.selectedStorage.storageName;
    this.description = this.selectedStorage.description;
    this.active = this.selectedStorage.active;
    this.processStep = this.processStepMap.get(this.selectedStorage.processStep);
    this.displayDialog = true;

  }

  checkFormValidity(){
    if(this.storageName==undefined || this.storageName==null || this.storageName==''){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Storage Name Empty.',
        detail: "Storage Name cannot be empty. Please give name to storage."
      });
      this.findAndHighlightElement("form-storage-name");
      return false;
    }

    if(this.processStep==undefined || this.processStep.value==undefined || this.processStep.value==null || this.processStep.value==''){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Process Step Empty.',
        detail: "Process Step cannot be empty. Please select a process step."
      });
      return false;
    }

    if(this.description==undefined || this.description==null || this.description==''){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Description Empty.',
        detail: "Description cannot be empty. Please write some description for the storage."
      });
      this.findAndHighlightElement("form-description");
      return false;
    }

    return true;
  }

  updateStorage(){
    if(!this.checkFormValidity())
    return;

    let storageOBJ = new Storage();
    storageOBJ.storageName = this.storageName;
    storageOBJ.processStep = this.processStep.value;
    storageOBJ.description = this.description;
    storageOBJ.labID = this.selectedLabId;
    storageOBJ.active = this.active;
    storageOBJ.plateIDs = this.selectedStorage.plateIDs;
    storageOBJ.version = this.selectedStorage.version;
    this.displayDialog = false;

    this._maStorageService.editStorageDetails(storageOBJ, this.selectedLabId, this.selectedStorage.storageName).subscribe(
      (result)=>{
        this.storageList[this.storageEditIndex] = result;
        this.fetchStorageLocationList();
      },
      (error)=>{
        this._messagesService.addErrorMessage({
          severity: 'error', summary: 'Storage not updated.',
          detail: error.error
        });
      }
    )
  }

  fetchStorageDetails(event: LazyLoadEvent = undefined){
    if(event == undefined){
      this._maStorageService.fetchAllStorage(this.selectedLabId,0,10, this.showActiveStorages).subscribe(
        (result)=> {
          this.storageList = result.paginatedResults;
          if (result.totalCount[0] != undefined || result.totalCount[0] != null)
            this.totalStorages = result.totalCount[0]['count'];
          else
            this.totalStorages = 0;
        },
        (error) => {
          this.loading = false;
          this._messagesService.addErrorMessage({
            severity: 'error', summary: 'Storage Locations Not Fetched',
            detail: "Some error occured in fetching storage locations."
          });
        }
      );
    }
    else{
      this.loading = true;
      this._maStorageService.fetchAllStorage(this.selectedLabId,event.first,10, this.showActiveStorages).subscribe(
        (result) => {
          this.storageList = result.paginatedResults;
          if (result.totalCount[0] != undefined || result.totalCount[0] != null)
            this.totalStorages = result.totalCount[0]['count'];
          else
            this.totalStorages = 0;
          this.loading = false;
        },
        (error) => {
          this.loading = false;
          this._messagesService.addErrorMessage({
            severity: 'error', summary: 'Storage Locations Not Fetched',
            detail: "Some error occured in fetching storage locations."
          });
        }
      );
    }
  }

  fetchStorageLocationList(){
    this.blocked = true
    this.storageLocationList = [];
    this._maStorageService.fetchActiveStorageLocations(this.selectedLabId).subscribe(
      (result) => {
        this.blocked = false
        this.storageLocationList = result.datalist;
      },
      error => {
        this.blocked = false
        this._messagesService.addErrorMessage({
          severity:'error',summary:'Error while fetching storage',
          detail:error
        })
      }
    )
  }

  searchForPlate(){
    if(this.enteredPlateID === '' || this.enteredPlateID === undefined){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Plate Not Scanned',
        detail: "PlateID cannot be empty. Please scan a plate."
      });
      this.findAndHighlightElement("plate-id-input");
      return;
    }
    this._maStorageService.searchStorageByPlate(this.selectedLabId, this.enteredPlateID).subscribe(
      (result) => {
        if(result.storageName != undefined){
          this._messagesService.addWarningMessage({
            severity: 'warn', summary: 'Plate Already Stored',
            detail: this.enteredPlateID+" already present in - "+result.storageName
          });
          this.enteredPlateID = '';
          this.findAndHighlightElement("plate-id-input");
          return true;
        }
        return false;
      }
    )
    return false;
  }
  onSelectedOptionChanged(event: any){
    let selectedStorage = event.value.storageName
    if(this.multiOldStorageList.has(selectedStorage)){
      this.disableStoreButton = true
      this._messagesService.addWarningMessage({
        severity:'warn',summary:"Conflicting storage location",
        detail:`Some of the plates are stored in the selected storage location ${selectedStorage}. Please change the destination storage and try again.`
      })
      return
    }
    this.disableStoreButton = false
  }
  addPlateToStorage(){
    if(this.enteredPlateID === '' || this.enteredPlateID === undefined){
      this.showStoreDialog()
    }
    else{
      this.checkIfPlateExists('single',this.enteredPlateID)
    }
  }

  restorePlateFromStorage(){
    if(this.enteredPlateID === '' || this.enteredPlateID === undefined){
      this.showRestoreDialog()
    }
    else{
      this.removePlateFromStorage()
    }
  }

  addSinglePlateToStorage(receptionProcessingPlate : boolean = false){
    if(this.selectedStorageLocation === '' || this.selectedStorageLocation === undefined){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Storage Location Not Selected',
        detail: "Storage location cannot be empty. Please select a storage location."
      });
      return;
    }
    if(this.enteredPlateID === '' || this.enteredPlateID === undefined){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Plate Not Scanned',
        detail: "PlateID cannot be empty. Please scan a plate."
      });
      this.findAndHighlightElement("plate-id-input");
      return;
    }
    this.blocked = true
    this._maStorageService.searchStorageByPlate(this.selectedLabId, this.enteredPlateID).subscribe(
      result => {
        this.blocked = false
        const currentPlateLocationInStorage = result.storageName
        if(currentPlateLocationInStorage === this.selectedStorageLocation){
          this._messagesService.addWarningMessage({
            severity:'warn',summary:'Invalid operation',
            detail:`Plate ${this.enteredPlateID} is already in ${result.storageName}. Cannot move to the same location.`
          })
          this.enteredPlateID = ""
          this.findAndHighlightElement('plate-id-input')
          return
        }

        const plateMigratingData: StoragePlateDTO = {
          labid: this.selectedLabId,
          plateid: this.enteredPlateID,
          storageName: this.selectedStorageLocation,
          oldStorageName: currentPlateLocationInStorage
        };
        this.blocked = true
        this._maStorageService.addPlateToStorage(plateMigratingData).subscribe(
          _r => {
            this.blocked = false
            this._messagesService.addSuccessMessage({
              severity: 'success', summary: 'Plate Added Successfully',
              detail: `${this.enteredPlateID} added successfully to storage ${this.selectedStorageLocation}`
            });
            this.fetchStorageDetails();
            this.enteredPlateID = '';
          },
          error => {
            this.blocked = false
            this._messagesService.addErrorMessage({
              severity: 'error', summary: 'Plate Not Added',
              detail: error.statusText
            });
          }
        )
      },
      _e =>{
        let plateData: StoragePlateDTO = {
          labid: this.selectedLabId,
          plateid: this.enteredPlateID,
          storageName: this.selectedStorageLocation
        };
        this.blocked = true
        this._maStorageService.addPlateToStorage(plateData).subscribe(
          _r => {
            this.blocked = false
            this._messagesService.addSuccessMessage({
              severity: 'success', summary: 'Plate Added Successfully',
              detail: `${this.enteredPlateID} added successfully to storage ${this.selectedStorageLocation}`
            });
            this.fetchStorageDetails();
            this.multiStorePlateList.push({plateId:this.enteredPlateID,isProcessingPlate:receptionProcessingPlate})
            if(!receptionProcessingPlate){
              this.markPlatesAsStorage()
            }
            this.enteredPlateID = '';
          },
          (error) => {
            this.blocked = false
            this._messagesService.addErrorMessage({
              severity: 'error', summary: 'Plate Not Added',
              detail: error.error
            });

          }
        );
        this.findAndHighlightElement("plate-id-input");
      }
    )
  }

  addMultiPlateToStorage(){
    if(this.selectedStorageLocation === '' || this.selectedStorageLocation === undefined){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Storage Location Not Selected',
        detail: "Storage location cannot be empty. Please select a storage location."
      });
      return;
    }
    if(this.multiStorePlateList.length === 0){
      this._messagesService.addErrorMessage({
        severity: 'warn', summary: 'Plates Not Added',
        detail: "Add the plates which needs to be stored"
      });
      this.findAndHighlightElement("store-plate-id")
      return
    }

    const multiPlateData = {
      "storageName":this.selectedStorageLocation,
      "plateids": this.multiStorePlateList.map(plate => plate.plateId),
      "labid":this.selectedLabId,
      "storageMigration": Array.from(this.multiOldStorageList)
    }
    this.blocked = true
    this._maStorageService.addMultiplePlatesToStorage(multiPlateData).subscribe(
      _r => {
        this.blocked = false
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'Plates Added Successfully',
          detail:`${this.multiStorePlateList.length} plates added successfully to storage ${this.selectedStorageLocation}`
        });
        this.markPlatesAsStorage()
      },
      error => {
        this.blocked = false
        this._messagesService.addErrorMessage({
          severity: 'error', summary: 'Plate Not Added',
          detail: error.error
        });
      }
    )
  }

  showPlates(index: any){
    this.selectedStorage = this.storageList[index];
    this.storedPlatesHeader = "Stored Plates in "+this.selectedStorage.storageName;
    this.displayPlatesDialog = true;
  }

  showDescription(index: any){
    this.selectedStorage = this.storageList[index];
    this.descriptionHeader = "Description of "+this.selectedStorage.storageName;
    this.displayDescriptionDialog = true;
  }

  showRestoreDialog(){
    this.restoreHeader = "Restore plates"
    this.displayRestoreDialog = true
    setTimeout(() => this.findAndHighlightElement('restore-plate-id'), 100)
  }

  showStoreDialog(){
    this.storeHeader = "Store plates"
    this.displayStoreDialog = true
    setTimeout(() => this.findAndHighlightElement('store-plate-id'), 100)
  }

  clearValues(){
    this.storageName = '';
    this.processStep = undefined;
    this.description = '';
    this.active = true;
    this.storageEdit = false;
  }

  findAndHighlightElement(elementId){
    let element = document.getElementById(elementId);
    if(element){
      element.focus();
    }
  }

  searchActiveStorages(){
    if(this.enteredPlateID === '' || this.enteredPlateID === undefined){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Plate Not Scanned',
        detail: "PlateID cannot be empty. Please scan a plate."
      });
      this.findAndHighlightElement("plate-id-input");
      return;
    }
    this._maStorageService.searchStorageByPlate(this.selectedLabId, this.enteredPlateID).subscribe(
      (result) => {
        if(result.storageName != undefined){
          this.selectedStorage = result;
          this.storedPlatesHeader = "Stored Plates in "+this.selectedStorage.storageName;
          this.displayPlatesDialog = true;
        }
      },
      (error) => {
        this._messagesService.addWarningMessage({
          severity: 'warn', summary: 'Plate not Stored',
          detail: this.enteredPlateID+" is not stored in any storage"
        });
        this.enteredPlateID = '';
        this.findAndHighlightElement("plate-id-input");
      }
    )
  }

  closeDialogs(type:string){
    if(type === 'store'){
      this.displayStoreDialog = false
      this.multiOldStorageList.clear()
      this.multiStorePlateList = []
      this.enteredStorePlateID = ""
    }
    else{
      this.displayRestoreDialog = false
      this.multiRestorePlateList = []
      this.enteredRestorePlateID = ""
    }
  }

  checkIfPlateExists(type: string,plateId: string){
    this.blocked = true
    this._maStorageService.checkIfPlateExists(this.selectedLabId,plateId).subscribe(
      result => {
        this.blocked = false
        if(!result.present){
          this._messagesService.addErrorMessage({
            severity:'error',summary:'Plate does not exist',
            detail:`Plate ${type === 'single'? this.enteredPlateID : this.enteredStorePlateID } does not exist. Please verify and try again!`
          })
          this.enteredPlateID = ""
          type === 'single' ? this.findAndHighlightElement('plate-id-input'): this.findAndHighlightElement('store-plate-id')
          return
        }
        const isReceptionProcessingPlate = result.plateStatus === PlateStatus.PLATE_CREATED && result.storagePlate === false
        type === 'single' ? this.addSinglePlateToStorage(isReceptionProcessingPlate) : this.checkPlateNotInStorage(isReceptionProcessingPlate)
        return
      },
      error => {
        this.blocked = false
        this._messagesService.addErrorMessage({
          severity: 'error',summary: 'Error occurred',
          detail: error.error
        })
      }
    )
  }

  checkPlateNotInStorage(isReceptionProcessingPlate: boolean = false){
    if(this.multiStorePlateList.find(plate => plate.plateId === this.enteredStorePlateID)){
      this._messagesService.addWarningMessage({
        severity:"warn",summary:"Plate already present",
        detail:`${this.enteredStorePlateID} is already added to the list`
      })
      this.findAndHighlightElement("restore-plate-id")
      return
    }
    if(this.multiStorePlateList.length === 20){
      this._messagesService.addWarningMessage({
        severity:"warn",summary:"Maximum capacity",
        detail:"Up to 20 plates can be sent for storage simultaneously."
      })
      return
    }
    this.blocked = true
    this._maStorageService.searchStorageByPlate(this.selectedLabId,this.enteredStorePlateID).subscribe(
      result => {
        this.blocked = false
        let currentPlateStorage = result.storageName
        if(currentPlateStorage === this.selectedStorageLocation){
          this._messagesService.addWarningMessage({
            severity:'warn',summary:'Invalid operation',
            detail:`Plate ${this.enteredStorePlateID} is already in ${currentPlateStorage}. Cannot move to the same location.`
          })
          this.findAndHighlightElement("store-plate-id")
          return
        }
        this.multiOldStorageList.add(currentPlateStorage)
        this.multiStorePlateList.push({plateId:this.enteredStorePlateID,isProcessingPlate:isReceptionProcessingPlate})
        this.enteredStorePlateID = ""
        this.findAndHighlightElement("store-plate-id")
      },
      _e => {
        this.blocked = false
        this.multiStorePlateList.push({plateId:this.enteredStorePlateID,isProcessingPlate:isReceptionProcessingPlate})
        this.enteredStorePlateID = ""
        this.findAndHighlightElement("store-plate-id")
      }
    )
  }

  checkPlateInStorage(){
    if(this.multiRestorePlateList.includes(this.enteredRestorePlateID)){
      this._messagesService.addWarningMessage({
        severity:"warn",summary:"Plate already present",
        detail:`${this.enteredRestorePlateID} is already added to the list`
      })
      this.enteredRestorePlateID = ""
      this.findAndHighlightElement("restore-plate-id")
      return
    }

    if(this.multiRestorePlateList.length === 20){
      this._messagesService.addWarningMessage({
        severity:"warn",summary:"Maximum capacity",
        detail:"Up to 20 plates can be sent for restoration simultaneously."
      })
      return
    }
    this.blocked = true
    this._maStorageService.getPlateDetails(this.selectedLabId,this.enteredRestorePlateID).subscribe(
      plate =>{
        this._maStorageService.searchStorageByPlate(this.selectedLabId,this.enteredRestorePlateID).subscribe(
          _r => {
            this.blocked = false
            if(plate.status === PlateStatus.PLATE_CREATED && plate.storagePlate === true){
              this.multiPlateCreatedAndStorageAsTrue.push({plateId:this.enteredRestorePlateID,index:this.multiRestorePlateList.length + 1})
            }
            this.multiRestorePlateList.push(this.enteredRestorePlateID)
            if(plate.status === PlateStatus.STORAGE_PLATE){
              this.multiStoragePlateFromReception.push(this.enteredRestorePlateID)
            }
            this.enteredRestorePlateID = ""
            this.findAndHighlightElement("restore-plate-id")
          },
          _e => {
            this.blocked = false
            this._messagesService.addWarningMessage({
              severity:"warn",summary:"Plate not present!",
              detail:`${this.enteredRestorePlateID} is not in any storage`
            })
            this.enteredRestorePlateID = ""
            this.findAndHighlightElement("restore-plate-id")
          }
        )
      },
      _e => {
        this.blocked = false
        this._messagesService.addWarningMessage({
          severity:"warn",summary:"Plate not present!",
          detail:`${this.enteredRestorePlateID} is not present.Please try again`
        })
        this.enteredRestorePlateID = ""
        this.findAndHighlightElement("restore-plate-id")
      }
    )


  }

  removePlateFromStoreList(index: number){
    this.multiStorePlateList.splice(index,1)
  }
  removePlateFromRestoreList(index:number){
    this.multiRestorePlateList.splice(index,1)
    this.multiPlateCreatedAndStorageAsTrue = this.multiPlateCreatedAndStorageAsTrue.filter(plate => plate.index !== index)
  }

  removePlateFromStorage(){
    let body = {
      "labid":this.selectedLabId,
      "plateid":this.enteredPlateID,
    }
    this.blocked = true
    this._maStorageService.getPlateDetails(this.selectedLabId,this.enteredPlateID).subscribe(
      plate => {
        this._maStorageService.removePlateFromStorage(body).subscribe(
          result => {
            this.blocked = false
            this._messagesService.addSuccessMessage({
              severity:"success",summary:"Restoration success",
              detail:result
            })

            let isSudoStoragePlate = plate.status === PlateStatus.PLATE_CREATED && plate.storagePlate === true
            if(isSudoStoragePlate){
              this.fetchStorageDetails()
              return
            }

            if(plate.status !== PlateStatus.STORAGE_PLATE){
              let normalPlateList = [this.enteredPlateID]
              this.markPlatesAsNormal(normalPlateList)
              return
            }

            this.markPlatesAsNormal([],[this.enteredPlateID])
          },
          error => {
            this.blocked = false
            this._messagesService.addErrorMessage({
              severity:"error",summary:"Restoration failed",
              detail:error
            })
            return
          }
        )
      },
      error => {
        this.blocked = false
        this._messagesService.addErrorMessage({
          severity:"error",summary:"Restoration failed",
          detail:error
        })
      }
    )
  }

  removeMultiplePlatesFromStorage(){
    if(this.multiRestorePlateList.length === 0){
      this._messagesService.addWarningMessage({
        severity:"warn",summary:"Plates not added",
        detail:"Please add the plates which requires restoration"
      })
      return
    }
    let body = {
      "labid":this.selectedLabId,
      "plateids":this.multiRestorePlateList
    }
    this.blocked = true
    this._maStorageService.removeMultiplePlatesFromStorage(body).subscribe(
      result => {
        this.blocked = false
        this._messagesService.addSuccessMessage({
          severity:"success",summary:"Restoration success",
          detail:result
        })
        let nonStoragePlateList = body.plateids.filter(plateId => {
          if (!this.multiStoragePlateFromReception.includes(plateId)) {
              const plateCreatedAndStorageAsTrue = this.multiPlateCreatedAndStorageAsTrue.find(plate => plate.plateId === plateId);
              if (!plateCreatedAndStorageAsTrue) {
                  return true;
              }
          }
          return false;
      })

      this.markPlatesAsNormal(nonStoragePlateList,this.multiStoragePlateFromReception)
      },
      error => {
        this.blocked = false
        this._messagesService.addErrorMessage({
          severity:"error",summary:"Restoration failed",
          detail:error
        })
      }
    )
  }

  markPlatesAsStorage(){
    if(this.multiStorePlateList.length === 0){
      return
    }
    let body = {
      'storageLocation': this.selectedStorageLocation,
      'plateIDs':this.multiStorePlateList.filter(plate => !plate.isProcessingPlate).map(plate => plate.plateId)
    }
    this.blocked = true
    this._maStorageService.markPlatesAsStorage(this.selectedLabId,body).subscribe(
      _result => {
        this.blocked = false
        this.multiStorePlateList = []
        this.closeDialogs('store')
        this.fetchStorageDetails()
      } ,
      error => {
        this.blocked = false
        this._messagesService.addErrorMessage({
          severity:'error',summary:'Somthing went wrong',
          detail:error
        })
        return
      }
    )
  }

  markPlatesAsNormal(storagePlateList:string[] = [],receptionPlateList:string[] = []){
    let body = {
      'plateIDs':storagePlateList,
      'receptionPlateIDs':receptionPlateList
    }
    this.blocked = true
    this._maStorageService.restorePlatesFromStorage(this.selectedLabId,body).subscribe(
      _result => {
        this.blocked = false
        this.multiRestorePlateList = []
        this.multiStoragePlateFromReception = []
        this.closeDialogs('restore')
        this.fetchStorageDetails()
      },
      error => {
        this.blocked = false
        this.multiRestorePlateList = []
        this.multiStoragePlateFromReception = []
        this._messagesService.addErrorMessage({
          severity:'error',summary:'Something went wrong',
          detail:error
        })
      }
    )
  }
}
